import { VehicleBaseInfo } from "@talladega/types";

function vehicleToString(vehicle: VehicleBaseInfo): string {
  const year = vehicle.year ?? "";
  const make = vehicle.make ?? "";
  const model = vehicle.model ?? "";
  const trim = vehicle.trim ?? "";

  return `${year}${make}${model}${trim}`.toLowerCase().replace(/\s+/g, "");
}

function convertToVehicleArray(vehicle: VehicleBaseInfo): VehicleBaseInfo[] {
  const trims = ([] as string[]).concat(vehicle.trim ?? "");
  return trims.flatMap((trim) => {
    return { ...vehicle, trim } as VehicleBaseInfo;
  });
}

export default function vehicleInfoEqualityChecker(
  subject: VehicleBaseInfo,
  template: VehicleBaseInfo
): boolean {
  if (template.trim) {
    if (!subject.trim) return false;

    const subjects = convertToVehicleArray(subject);
    const templates = convertToVehicleArray(template);

    return (
      subjects.filter(
        (sv) =>
          templates.filter((tv) => vehicleToString(tv) === vehicleToString(sv))
            .length > 0
      ).length > 0
    );
  }

  // If Template has no trim proceed to compare Year, Make and Model.
  return (
    vehicleToString({ ...template, trim: null }) ===
    vehicleToString({ ...subject, trim: null })
  );
}
